import React from 'react'

function RedStar() {
    return (
        <strong><span style={{color:'red'}}>*</span></strong>
        )
}
export default RedStar